export default __webpack_public_path__ + "static/media/forgot.646d2f70.svg";